import _toConsumableArray from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../../chunks/tslib.es6.js";
import "../../geometry.js";
import t from "../../core/Handles.js";
import { abortMaybe as i, isSome as o, destroyMaybe as s, isNone as r } from "../../core/maybe.js";
import { property as n } from "../../core/accessorSupport/decorators/property.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import "../../core/accessorSupport/ensureType.js";
import { subclass as a } from "../../core/accessorSupport/decorators/subclass.js";
import { drawingModes as d, defaultDrawingMode as h } from "./DrawingMode.js";
import p from "./DrawAction.js";
import { DrawTool as l } from "./DrawTool.js";
import { VertexRemoveEvent as _, VertexAddEvent as c, CursorUpdateEvent as v, DrawCompleteEvent as u } from "./input/DrawEvents.js";
import { ViewEventPriorities as m } from "../input/InputManager.js";
import { SKETCH_KEYS as w } from "../interactive/keybindings.js";
import { createScreenPointFromEvent as g } from "../support/screenUtils.js";
import T from "../../geometry/Point.js";

var y = /*#__PURE__*/function (_p) {
  _inherits(y, _p);

  var _super = _createSuper(y);

  function y(e) {
    var _this;

    _classCallCheck(this, y);

    _this = _super.call(this, e), _this._panEnabled = !1, _this._popVertexOnPointerMove = !1, _this._addVertexOnPointerUp = !1, _this._activePointerId = null, _this._viewHandles = new t(), _this._undoRedoHandles = new t(), _this.mode = h;
    return _this;
  }

  _createClass(y, [{
    key: "initialize",
    value: function initialize() {
      "2d" === this.view.type ? (this._addViewHandles(), this._addUndoRedoHandles()) : this._addDrawTool(this.view);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      "2d" === this.view.type ? (this._removeViewHandles(), this._viewHandles.destroy(), this._removeUndoRedoHandles(), this._undoRedoHandles.destroy()) : this._removeDrawTool(), this.emit("destroy");
    }
  }, {
    key: "_dragEnabled",
    get: function get() {
      return "freehand" === this.mode || "hybrid" === this.mode;
    }
  }, {
    key: "_clickEnabled",
    get: function get() {
      return "click" === this.mode || "hybrid" === this.mode;
    }
  }, {
    key: "undo",
    value: function undo() {
      _get(_getPrototypeOf(y.prototype), "undo", this).call(this), this.notifyChange("vertices");
    }
  }, {
    key: "redo",
    value: function redo() {
      _get(_getPrototypeOf(y.prototype), "redo", this).call(this), this.notifyChange("vertices");
    }
  }, {
    key: "complete",
    value: function complete() {
      "2d" === this.view.type ? this._completeDrawing() : this._drawTool.completeCreateOperation();
    }
  }, {
    key: "getGeometryZValue",
    value: function getGeometryZValue() {
      return this.vertices.length > 0 && this.vertices[0].length > 2 ? this.vertices[0][2] : this._get("defaultZ");
    }
  }, {
    key: "_addViewHandles",
    value: function _addViewHandles() {
      var _this2 = this;

      this._removeViewHandles(), this._viewHandles.add([this.view.on("click", function (e) {
        e.stopPropagation();
      }, m.TOOL), this.view.on("pointer-down", function (e) {
        _this2._shouldHandlePointerEvent(e) && (_this2._snappingTask = i(_this2._snappingTask), _this2._activePointerId = e.pointerId, _this2._addVertexOnPointerUp = !0, _this2._cursorScreenPoint = g(e), "touch" === e.pointerType && _this2._updateCursor(e.native));
      }, m.TOOL), this.view.on("pointer-move", function (e) {
        _this2._snappingTask = i(_this2._snappingTask), _this2._popVertexOnPointerMove && (_this2.undo(), _this2._popVertexOnPointerMove = !1), _this2._cursorScreenPoint = g(e), "touch" !== e.pointerType && _this2._updateCursor(e.native);
      }, m.TOOL), this.view.on("pointer-drag", function (e) {
        _this2._shouldHandlePointerEvent(e) && (_this2._snappingTask = i(_this2._snappingTask), _this2._cursorScreenPoint = g(e), _this2._dragEnabled && !_this2._panEnabled ? _this2._vertexAddHandler(e) : _this2._addVertexOnPointerUp = !1);
      }, m.TOOL), this.view.on("pointer-up", function (e) {
        if (_this2._shouldHandlePointerEvent(e)) if (_this2._snappingTask = i(_this2._snappingTask), _this2._activePointerId = null, _this2._addVertexOnPointerUp) {
          if (!_this2._clickEnabled) return 1 === _this2.vertices.length && _this2.vertices.pop(), void _this2._drawCompleteHandler(e);

          _this2._vertexAddHandler(e);
        } else {
          var _t = "touch" === e.pointerType;

          _this2._updateCursor(e.native, _t);
        }
      }, m.TOOL), this.view.on("drag", function (e) {
        _this2._dragEnabled && o(_this2._activePointerId) && !_this2._panEnabled && e.stopPropagation();
      }, m.TOOL), this.view.on("drag", ["Shift"], function (e) {
        e.stopPropagation();
      }, m.TOOL), this.view.on("double-click", function (e) {
        e.stopPropagation(), _this2._drawCompleteHandler(e);
      }, m.TOOL), this.view.on("double-click", ["Control"], function (e) {
        e.stopPropagation(), _this2._drawCompleteHandler(e);
      }, m.TOOL), this.view.on("key-down", function (e) {
        var t = e.key,
            o = e.repeat;
        t === w.vertexAdd && !o && _this2._cursorScreenPoint ? (e.stopPropagation(), _this2._snappingTask = i(_this2._snappingTask), _this2._vertexAddHandler(e)) : t !== w.complete || o ? t !== w.undo || _this2.interactiveUndoDisabled || o ? t !== w.redo || _this2.interactiveUndoDisabled || o ? t !== w.pan || o || (e.stopPropagation(), _this2._panEnabled = !0) : (e.stopPropagation(), _this2.redo()) : (e.stopPropagation(), _this2.undo()) : (e.stopPropagation(), _this2._drawCompleteHandler(e));
      }, m.TOOL), this.view.on("key-up", function (e) {
        e.key === w.pan && (e.stopPropagation(), _this2._panEnabled = !1);
      }, m.TOOL)]);
    }
  }, {
    key: "_addUndoRedoHandles",
    value: function _addUndoRedoHandles() {
      var _this3 = this;

      this._removeUndoRedoHandles(), this._undoRedoHandles.add([this._editGeometryOperations.on("vertex-remove", function (e) {
        if (_this3.notifyChange("vertices"), "undo" === e.operation) {
          var _t2 = _this3._nativeEventHistory.undoStack.pop();

          _this3._nativeEventHistory.redoStack.push(_t2);

          var _i = _toConsumableArray(_this3._committedVertices);

          o(_this3._stagedVertex) && _i.push(_this3._coordinateHelper.pointToArray(_this3._stagedVertex)), _this3.emit("undo", new _(_this3.view, _t2, e.vertices[0].index, _i));
        }
      }), this._editGeometryOperations.on("vertex-add", function (e) {
        if (_this3.notifyChange("vertices"), "apply" === e.operation) {
          var _e = _this3._nativeEventHistory.undoStack[_this3._nativeEventHistory.undoStack.length],
              _t3 = _this3._committedVertices.length - 1,
              _i2 = new c(_this3.view, _e, _t3, _this3.vertices);

          _this3.emit("vertex-add", _i2), _i2.defaultPrevented && (_this3._popVertexOnPointerMove = !0);
        } else if ("redo" === e.operation) {
          var _t4 = _this3._nativeEventHistory.redoStack.pop();

          _this3._nativeEventHistory.undoStack.push(_t4);

          var _i3 = _toConsumableArray(_this3._committedVertices);

          o(_this3._stagedVertex) && _i3.push(_this3._coordinateHelper.pointToArray(_this3._stagedVertex)), _this3.emit("redo", new c(_this3.view, _t4, e.vertices[0].index, _i3));
        }
      })]);
    }
  }, {
    key: "_removeViewHandles",
    value: function _removeViewHandles() {
      this._viewHandles.removeAll();
    }
  }, {
    key: "_removeUndoRedoHandles",
    value: function _removeUndoRedoHandles() {
      this._undoRedoHandles.removeAll();
    }
  }, {
    key: "_addDrawTool",
    value: function _addDrawTool(e) {
      var _this4 = this;

      this._drawTool = new l({
        view: e,
        elevationInfo: this.elevationInfo,
        hasZ: this.hasZ,
        geometryType: "polygon",
        mode: this.mode
      }), this.view.addAndActivateTool(this._drawTool), this._drawTool.on("vertex-add", function (e) {
        1 === e.vertices.length && _this4.emit("vertex-add", new c(_this4.view, null, e.vertices[0].vertexIndex, _this4._drawTool.getVertexCoords()));
      }), this._drawTool.on("cursor-update", function (e) {
        1 === e.vertices.length && _this4.emit("cursor-update", new v(_this4.view, null, e.vertices[0].vertexIndex, _this4._drawTool.getVertexCoords()));
      }), this._drawTool.on("complete", function (e) {
        _this4.emit("draw-complete", new u(null, _this4._drawTool.getVertexCoords())), _this4._removeDrawTool();
      });
    }
  }, {
    key: "_removeDrawTool",
    value: function _removeDrawTool() {
      this.view.tools.remove(this._drawTool), this._drawTool = s(this._drawTool);
    }
  }, {
    key: "_addVertex",
    value: function _addVertex(e, t) {
      var i = this._coordinateHelper.arrayToVector(e);

      if (this._isDuplicateOfLastVertex(i)) return;
      this._lastVertexUnsnapped = this._stagedVertexUnsnapped, this._popCursorVertex(), this._editGeometryOperations.appendVertex(i);
      var o = t || new Event("placeholder");

      this._nativeEventHistory.undoStack.push(o);
    }
  }, {
    key: "_updateCursor",
    value: function _updateCursor(e) {
      var _this5 = this;

      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      if (this._popCursorVertex(), !this._cursorScreenPoint) return;
      var i = this.getCoordsAndPointFromScreenPoint(this._cursorScreenPoint);

      if (o(i) && !t) {
        this._pushCursorVertex(i.vertex);

        var _t5 = function _t5() {
          return new v(_this5.view, e, _this5._activeComponent.vertices.length, _this5.vertices, o(_this5._stagedVertex) ? new T(_this5._stagedVertex) : null);
        };

        this.emit("cursor-update", _t5()), o(this._snappingTask) && this._snappingTask.promise.then(function (e) {
          e.valid && _this5.emit("cursor-update", _t5());
        }, function () {});
      }
    }
  }, {
    key: "_completeDrawing",
    value: function _completeDrawing(e) {
      if (this._activePointerId = null, this._popCursorVertex(), this._committedVertices.length < 3) return;
      this._snappingTask = i(this._snappingTask), o(this._snappingManager) && this._snappingManager.doneSnapping();
      var t = new u(e, this.vertices);
      this.emit("draw-complete", t), t.defaultPrevented || this._removeViewHandles();
    }
  }, {
    key: "_shouldHandlePointerEvent",
    value: function _shouldHandlePointerEvent(e) {
      return x(e) && (r(this._activePointerId) || this._activePointerId === e.pointerId);
    }
  }]);

  return y;
}(p);

function x(e) {
  return "mouse" !== e.pointerType || 0 === e.button;
}

e([n()], y.prototype, "_dragEnabled", null), e([n()], y.prototype, "_clickEnabled", null), e([n({
  type: d
})], y.prototype, "mode", void 0), y = e([a("esri.views.draw.PolygonDrawAction")], y);
export { y as PolygonDrawAction };